import React, { useContext, memo, useEffect, useRef } from 'react';

import * as S from './GettingStartedStyles';
import { ResponsiveContainer, Heading, FlexDiv, GenericP } from 'commonStyles';
import DisplayContext from 'UtilityComponents/displayContext';
import { GettingStartedData } from '../../config';
import Button from 'common/Button/Button';
import { loadNextComponent, scrollToElem, trackClickEvents } from '../../utils';
import landingContext from '../../landingContext';

const GettingStarted = ({ showNextComp, nextComp, isScollView }) => {
	const displayName = useContext(DisplayContext).isMobile;
	const appContext = useContext(landingContext) || {};
	const isMobile = displayName == 'mobile';
	const { onSignUpClicked } = appContext;
	const { list, heading1, heading2 } = GettingStartedData;

	const refHtml = useRef();
	useEffect(() => {
		loadNextComponent(refHtml, showNextComp, nextComp);
	}, []);

	const createNowClick = (e)=>{
		onSignUpClicked(e);
		trackClickEvents('createnow_clicked');
	};

	useEffect(() => {
		if (isScollView && refHtml.current) {
			setTimeout(() => {
				scrollToElem(refHtml);
			}, 150);
		}
	}, [isScollView]);

	return (
		<ResponsiveContainer as='section' top_P='105' id='GettingStarted' ref={refHtml}>
			<Heading marBt='40px' as='h3' font_size={`${isMobile ? '28' : '48'}`}>
				{heading1}
				<br />  {heading2}
			</Heading>
			<FlexDiv wrap={isMobile ? 'wrap' : 'unset'} justify='space-between' style={{ 'min-height': '300px' }}>
				{list.map((data, index) => (
					<S.GettingStartedInnerWrap key={data.id}>
						<S.CircularDiv>{data.id}</S.CircularDiv>
						<S.GettingStartedLabel>{data.heading}</S.GettingStartedLabel>
						<GenericP fsize={isMobile ? '14px' : '22px'} color='#4a4a4a'>{data.descp}</GenericP>
					</S.GettingStartedInnerWrap>
				))}
			</FlexDiv>
			<Button
				btnTxt='CREATE NOW'
				btnType='Flat'
				btnName='Primary'
				btnShadow
				btnWidth={`${isMobile ? '100%' : '20%'}`}
				height='44px'
				handleClick={createNowClick}
			/>
		</ResponsiveContainer>
	);
};

export default memo(GettingStarted);
